export default __webpack_public_path__ + "static/media/g2.975952a3.png";